var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMastercard = function SvgMastercard(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1765 0H2.23578C1.13448 0 0.241699 0.89543 0.241699 2V14C0.241699 15.1046 1.13448 16 2.23578 16H22.1765C23.2778 16 24.1706 15.1046 24.1706 14V2C24.1706 0.89543 23.2778 0 22.1765 0Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21517 13C11.9684 13 14.2004 10.7614 14.2004 8C14.2004 5.23858 11.9684 3 9.21517 3C6.46193 3 4.22998 5.23858 4.22998 8C4.22998 10.7614 6.46193 13 9.21517 13Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1971 13C17.9503 13 20.1823 10.7614 20.1823 8C20.1823 5.23858 17.9503 3 15.1971 3C12.4439 3 10.2119 5.23858 10.2119 8C10.2119 10.7614 12.4439 13 15.1971 13Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.206 3.99963C13.4168 4.91184 14.2001 6.36418 14.2001 8C14.2001 9.63582 13.4168 11.0882 12.206 12.0004C10.9951 11.0882 10.2119 9.63582 10.2119 8C10.2119 6.36418 10.9951 4.91184 12.206 3.99963Z",
    fill: "#FF5F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9289,
    height: 16,
    fill: "white",
    transform: "translate(0.241699)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Mastercard.77c07a1403c7c7794ee021bde57c87a6.svg";